module.exports = __webpack_public_path__ + "img/918-6a7a29.png";